import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import Select, { MultiValue } from "react-select";
import {
  ascendingandDecending,
  companyName,
  documentType,
  duration,
  languageOptions,
  LocaleData,
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  status,
  statusList,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import DatePicker from "react-datepicker";
import { TagsInput } from "react-tag-input-component";
import DefaultEditor from "react-simple-wysiwyg";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { useParams } from "react-router-dom";
import { getCompanyDetail } from "./companyAPI";
import ActivityList from "../activity";
import { ACTIVITY_TYPES } from "../activity/activityAPI";
import { accountType, selectRelatedToType, selectAssignType, selectTaskCategoryOptions, selectTaskStatusOptions, selectTaskPriorityOptions, ratingOptions } from "../../../core/common/selectoption/selectoption";
import { createLogCall, deleteLogCall, viewMemberLogCall, updateLogCall, userList, detailLogCall, updateLogCallStatus, listLeadsOption, listContactsOptionn, listAccountsOption, listOpportunitiesOption } from "../leads/logcall_api";
import { createTask, deleteTask, viewMemberTasks, updateTask, detailTask } from "../leads/task_api";
import { createEvent, ViewMemberEvent, deleteEvent, getEventDetail, updateEvent } from "../leads/event_api";
import { getTagList } from "../tags/tagAPI";
import ResponseModal from "../../../core/modals/response_modal";
interface ContactInformation {
  accountId: number;
  name: string;
  phone: string;
  industry: string;
  description: string | null;
  noOfEmployees: number;
  website: string;
  ownerName: string;
  ownerUuid: string;
  language: string;
  rating: number;
  status: "ACTIVE" | "INACTIVE";
  facebookLink: string | null;
  skypeLink: string | null;
  linkedinLink: string | null;
  whatsappLink: string | null;
  instagramLink: string | null;
  twitterLink: string | null;
  country: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  public: boolean;
}

interface Tasks {
  id: number;
  uuid: string;
  title: string;
  category: string;
  responsible: { uuid: string; username: string };
  startDate: string;
  endDate: string;
  targetType: string;
  assignType: string;
  priority: string;
  status: string;
  description?: string
}

interface TagOption {
  value: number;
  label: string;
}
interface CreateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface UpdateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface TaskDetailDTO {
  title: string;
  category: string;
  responsible: { uuid: string; username: string }
  startDate: string;
  endDate: string;
  assignTags: Array<{ id: number; uuid: string; name: string }>;
  priority: string;
  status: string;
  description: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}

interface Opportunity {
  opportunityId: number;
  opportunityName: string;
  stage: string | null;
  amount: number;
  CompanyId: number;
  CompanyName: string;
  owner: string;
}

interface Tag {
  tagId: number;
  name: string;
}

interface CompanyDetail {
  contactInformation: ContactInformation;
  opportunities: Opportunity[];
  tagList: Tag[];
}
interface LogCall {
  id: number;
  uuid?: string;
  status: string;
  userCall?: string;
  callTime?: string;
  notes?: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
interface Event {
  id: number;
  uuid: string;
  subject: string;
  description: string;
  startTime: string;
  endTime: string;
}

interface LogCallDataCreate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType: string;
  assignRecord: number;
  targetType: string;
  targetRecord: number;
  checkedCreateFollowingTask: boolean;
}
interface LogCallDataUpdate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType?: string;
  assignRecord?: number;
  targetType?: string;
  targetRecord?: number;
}
interface LogCallDataDetail {
  id: number;
  uuid?: string;
  status: string;
  userCall: { uuid: string; username: string };
  callTime: string;
  notes: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}
interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface CampaignListDTO {
  campaignId: number;
  campaignName: string;
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}
interface Stage {
  id: number;
  name: string;
  order: number;
}
interface Account {
  accountId: number;
  accountName: string;
  type?: "new" | "existing";
}

interface Contact {
  contactId: number;
  contactName: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  type?: "new" | "existing";
}

interface Opportunity {
  id: number;
  name: string;
  type?: "new" | "existing";
}

interface Owner {
  id: number;
  name: string;
}

interface ConvertLeadForm {
  account: Account | null;
  contact: Contact | null;
  opportunity: Opportunity | null;
  owner: Owner | null;
  leadStatus?: string;
}
interface LeadConvert {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
}
interface CreateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface UpdateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface EventDetailDTO {
  subject: string;
  description: string;
  attendees: { id: number; name: string }[];
  location: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string }[];
  startTime: string;
  endTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

const getValidUrl = (url?: string | null): string => {
  if (!url) return "#";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};
const CompaniesDetails = () => {
  const route = all_routes;
  const [companyDetail, setCompanyDetail] = useState<CompanyDetail>({
    contactInformation: {} as ContactInformation,
    opportunities: [],
    tagList: [],
  });

  const { id } = useParams();
  const [reloadActivity, setReloadActivity] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [isEditor2, setIsEditor2] = useState(false);
  const [isEditor3, setIsEditor3] = useState(false);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUserCall, setSelectedUserCall] = useState("");
  const [selectedTaskResponsible, setSelectedTaskResponsible] = useState("");
  const [selectedLogCallId, setSelectedLogCallId] = useState<{ id: number } | null>(null);
  const [selectedTaskId, setSelectedTaskId] = useState<{ id: number } | null>(null);
  const [editingLogCall, setEditingLogCall] = useState<LogCallDataUpdate | null>(null);
  const [detailLogCallData, setDetailLogCallData] = useState<LogCallDataDetail | null>(null);
  const [editingTask, setEditingTask] = useState<TaskDetailDTO | null>(null);
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>([]);
  const [listContactAssignType, setListContactAssignType] = useState<ContactlListDTO[]>([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<AccountListDTO[]>([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] = useState<OpportunityListDTO[]>([]);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [stages, setStages] = useState<Stage[]>([]);
  const [logCallToCreate, setLogCallToCreate] = useState<LogCallDataCreate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show3, setShow3] = useState(false);
  const [logCalls, setLogCalls] = useState<LogCall[]>([]);
  const [tasks, setTasks] = useState<Tasks[]>([]);
  const [createdLeadUuid, setCreatedLeadUuid] = useState(null);
  const [editedLeadUuid, setEditedLeadUuid] = useState(null);
  const [leadToDelete, setLeadToDelete] = useState<{ id: number; name: string } | null>(null);
  const [logCallToDelete, setLogCallToDelete] = useState<{ id: number } | null>(null);
  const [taskToDelete, setTaskToDelete] = useState<{ id: number } | null>(null);
  const [showEditLogCallModal, setShowEditLogCallModal] = useState(false);
  const [showDeleteLogCallModal, setShowDeleteLogCallModal] = useState(false);
  const [logCallStatus, setLogCallStatus] = useState<string>("");
  const [logCallFollowUpDate, setLogCallFollowUpDate] = useState<string>("");
  const [logCallNote, setLogCallNote] = useState<string>("");
  const [logCallUserCall, setLogCallUserCall] = useState<string>("");
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  const [taskTitle, setTaskTitle] = useState<string>("");
  const [taskCategory, setTaskCategory] = useState<string>("");
  const [taskStartDate, setTaskStartDate] = useState<string>("");
  const [taskEndDate, setTaskEndDate] = useState<string>("");
  const [taskStatus, setTaskStatus] = useState<string>("");
  const [taskPiority, setTaskPriority] = useState<string>("");
  const [taskDescription, setTaskDescription] = useState<string>("");
  const [assignType, setAssignType] = useState("");
  const [relatedType, setSelectRelatedType] = useState("");
  const [assignTaskType, setAssignTaskType] = useState("");
  const [relatedTaskType, setSelectRelatedTaskType] = useState("");
  const [assignOptions, setAssignOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateOptions, setRelateOptions] = useState<{ value: number; label: string }[]>([]);
  const [selectedAssignOption, setSelectedAssignOption] = useState<{ value: number; label: string } | null>(null);
  const [selectedRelateOption, setSelectedRelateOption] = useState<{ value: number; label: string } | null>(null);
  const [assignTaskOptions, setAssignTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [selectedTaskAssignOption, setSelectedTaskAssignOption] = useState<{ value: number; label: string } | null>(null);
  const [selectedTaskRelateOption, setSelectedTaskRelateOption] = useState<{ value: number; label: string } | null>(null);
  const [accountOptions, setAccountOptions] = useState<{ value: string; label: string }[]>([]);
  const [contactOptions, setContactOptions] = useState<{ value: string; label: string }[]>([]);
  const [opportunityOptions, setOpportunityOptions] = useState<{ value: string; label: string }[]>([]);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const [accountType, setAccountType] = useState<"new" | "existing">("existing");
  const [contactType, setContactType] = useState<"new" | "existing">("existing");
  const [opportunityType, setOpportunityType] = useState<"new" | "existing">("existing");
  const [accountName, setAccountName] = useState("");
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [opportunityName, setOpportunityName] = useState("");
  const [selectedAccount, setSelectedAccount] = useState<{ value: string; label: string } | null>(null);
  const [selectedContact, setSelectedContact] = useState<{ value: string; label: string } | null>(null);
  const [selectedOpportunity, setSelectedOpportunity] = useState<{ value: string; label: string } | null>(null);
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);
  type OptionType = { value: string; label: string };
  const [selectedSalutation, setSelectedSalutation] = useState<string | null>(null);
  const [createLogCallFollowingTask, setLogCallCreateFollowingTask] = useState<boolean>(false);
  const [selectedLeadContactId, setSelectedLeadContactId] = useState<{ id: number } | null>(null);

  const ratingMap: Record<number, { text: string; color: string }> = {
    1: { text: "COLD", color: "#0dcaf0" },
    2: { text: "WARM", color: "#198754" },
    3: { text: "HOT", color: "#dc3545" },
  };
  useEffect(() => {
    const fetchCompanyDetail = async () => {
      try {
        const response = await getCompanyDetail(id);
        console.log("API Response:", response);
        const test = {
          contactInformation: response.data.data.contactInformation as ContactInformation,
          opportunities: response.data.data.opportunities,
          tagList: response.data.data.tagList
        };

        console.log("Test ", test);
        if (response?.data?.data) {
          setCompanyDetail(prevState => {
            console.log("Previous state:", prevState);
            console.log("New state:", test);
            return test;
          });
        } else {
          setCompanyDetail({ contactInformation: {} as ContactInformation, opportunities: [], tagList: [] });
        }
      } catch (error: any) {
        if (error.response?.data?.code === 1023) {
          navigate("/error-404");
        }
      }
    };

    if (id) {
      fetchCompanyDetail();
    }
  }, [id]);
  const [events, setEvents] = useState<Event[]>([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [eventDetail, setEventDetail] = useState<EventDetailDTO | null>(null);
  const [attendees, setAttendees] = useState<{ value: number; label: string }[]>([]);
  const [newEventData, setNewEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const [editEventData, setEditEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const attendeesOptions = listUserCall.map((user) => ({
    value: user.id,
    label: user.username,
  }));
  const selectedAttendees = attendeesOptions.filter(option =>
    editEventData.attendees.includes(option.value)
  );
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);
  const handleSelectAttendeesChange = (selectedOptions: any) => {
    setAttendees(selectedOptions);
    setNewEventData((prevData) => ({
      ...prevData,
      attendees: selectedOptions ? selectedOptions.map((option: { value: number }) => option.value) : [],
    }));
    setEditEventData({
      ...editEventData,
      attendees: selectedOptions.map((option: { value: number }) => Number(option.value)),
    });
  };


  const getNewEventData = (): CreateEventDTO => {
    return {
      subject: newEventData.subject,
      description: newEventData.description,
      attendees: newEventData.attendees,
      location: newEventData.location,
      startTime: newEventData.startTime
        ? new Date(
          new Date(newEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: newEventData.endTime
        ? new Date(
          new Date(newEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: newEventData.assignType,
      assigneeId: newEventData.assigneeId,
      targetType: newEventData.targetType,
      targetIds: newEventData.targetIds,
    };
  };
  const getEditEventData = (): UpdateEventDTO => {
    return {
      subject: editEventData.subject,
      description: editEventData.description,
      attendees: editEventData.attendees,
      location: editEventData.location,
      startTime: editEventData.startTime
        ? new Date(
          new Date(editEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: editEventData.endTime
        ? new Date(
          new Date(editEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: editEventData.assignType,
      assigneeId: editEventData.assigneeId,
      targetType: editEventData.targetType,
      targetIds: editEventData.targetIds,
    };
  };
  const handleCreateEvent = async () => {
    try {
      const newEvent = getNewEventData();
      const response = await createEvent(newEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event created successfully!" });
        fetchEvents();
        resetNewEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewEventForm = () => {
    setNewEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const resetEditEventForm = () => {
    setEditEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const fetchEvents = async () => {
    if (!companyDetail.contactInformation?.accountId) return;
    setLoading(true);
    setError("");
    try {
      const response = await ViewMemberEvent("ACCOUNT", companyDetail.contactInformation?.accountId);
      setEvents(response.data.data || []);
    } catch (err) {
      setError("Failed to load events.");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteEventClick = async (eventId: number) => {
    setSelectedEventId(eventId);
    setShowDeleteModal(true);
  }
  const handleDeleteEventConfirm = async () => {
    if (!selectedEventId) return;
    try {
      const response = await deleteEvent(selectedEventId);
      if (response.status === 200) {
        fetchEvents();
        setResponse({ status: "success", message: "Delete event successfully!" });
        setSelectedEventId(0);
      }
    } catch (error: any) {
      console.error("Failed to delete:", error);
      setResponse({ status: "error", message: error.response?.data?.message || "Failed to delete event." });
    } finally {
      setShowDeleteModal(false);
      setShowMessageModal(true);
    }
  };
  const fetchSelectedEvent = async (id: number) => {
    try {
      const response = await getEventDetail(id);
      const eventData = response.data.data as EventDetailDTO;
      setEventDetail({
        ...eventData,
        attendees: eventData.attendees || [],
        assignee: eventData.assignee || []
      });
      setEditEventData({
        subject: eventData.subject || "",
        description: eventData.description || "",
        attendees: eventData.attendees?.map(att => att.id) || "",
        location: eventData.location || "",
        assignType: eventData.assignType || "",
        assigneeId: eventData.assignee?.map(ass => ass.id) || 0,
        targetType: eventData.targetType || "",
        targetIds: eventData.targets ? eventData.targets.id : 0,
        startTime: eventData.startTime || "",
        endTime: eventData.endTime || ""
      });
      console.log("EventDetailabcxyz: ", editEventData)
    } catch (err) {
      console.error("Error fetching event details:", err);
    }
  };
  const handleEditClickEvent = (id: number) => {
    setSelectedEventId(id);
    fetchSelectedEvent(id);
  }
  const handleUpdateEvent = async () => {
    if (!selectedEventId) {
      return;
    }
    try {
      const editEvent = getEditEventData();
      const response = await updateEvent(selectedEventId, editEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event updated successfully!" });
        fetchEvents();
        resetEditEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event updated failed!" });
    } finally {
      setShowMessageModal(true);
    }
  };
  /*Events*/
  useEffect(() => {
    if (editingTask) {
      if (editingTask.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (editingTask.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }
      if (editingTask.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (editingTask.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
    }
  }, [editingTask, listLeadAssignType, listContactAssignType, listAccountRelatedToType, listOpportunitiesRelatedToType]);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const [newTaskData, setNewTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });

  const [editTaskData, setEditTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });
  const updateNewTaskField = (field: string, value: any) => {
    setNewTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateEditTaskField = (field: string, value: any) => {
    setEditTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const getNewTaskData = (): CreateTaskDTO => {
    return {
      memberId: companyDetail.contactInformation?.accountId ?? 0,
      title: newTaskData.title,
      category: newTaskData.category,
      responsible: newTaskData.responsible,
      startDate: newTaskData.startDate
        ? new Date(
          new Date(newTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: newTaskData.endDate
        ? new Date(
          new Date(newTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: newTaskData.status,
      priority: newTaskData.priority,
      description: newTaskData.description,
      assignType: newTaskData.assignType,
      assignId: newTaskData.assignId,
      targetType: newTaskData.targetType,
      targetId: newTaskData.targetId,
    };
  };
  const getEditTaskData = (): UpdateTaskDTO => {
    return {
      memberId: companyDetail.contactInformation?.accountId ?? 0,
      title: editTaskData.title,
      category: editTaskData.category,
      responsible: editTaskData.responsible,

      startDate: editTaskData.startDate
        ? new Date(
          new Date(editTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: editTaskData.endDate
        ? new Date(
          new Date(editTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: editTaskData.status,
      priority: editTaskData.priority,
      description: editTaskData.description,
      assignType: editTaskData.assignType,
      assignId: editTaskData.assignId,
      targetType: editTaskData.targetType,
      targetId: editTaskData.targetId,
    };
  };

  const handleCreateTasks = async () => {
    try {
      const newTask = getNewTaskData();
      const response = await createTask(newTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task created successfully!" });
        resetNewTaskForm();
        fetchTasks();
      }
    } catch (err) {
      console.error("Error creating task:", err);
      setResponse({ status: "error", message: "Task created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const handleUpdateTask = async (taskId: number) => {
    try {
      const updatedTask = getEditTaskData();
      const response = await updateTask(taskId, updatedTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task updated successfully!" });
        fetchTasks();
        resetEditTaskForm();
      }
    } catch (err) {
      console.error("Error updating task:", err);
      setResponse({ status: "error", message: "Task updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewTaskForm = () => {
    setNewTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };

  const resetEditTaskForm = () => {
    setEditTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };
  const [newLogCall, setNewLogCall] = useState<LogCallDataCreate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
    checkedCreateFollowingTask: false,
  });
  const resetAddLogCallForm = () => {
    setNewLogCall({
      userCall: "",
      status: "",
      followUpDate: "",
      note: "",
      assignType: "",
      assignRecord: 0,
      targetType: "",
      targetRecord: 0,
      checkedCreateFollowingTask: false,
    });
  };
  const getNewLogCallData = (): LogCallDataCreate => {
    return {
      userCall: newLogCall.userCall,
      status: newLogCall.status,
      followUpDate: newLogCall.followUpDate
        ? new Date(
          new Date(newLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: newLogCall.note,
      assignType: newLogCall.assignType,
      assignRecord: newLogCall.assignRecord,
      targetType: newLogCall.targetType,
      targetRecord: newLogCall.targetRecord,
      checkedCreateFollowingTask: newLogCall.checkedCreateFollowingTask,
    };
  };

  const [logCallDetail, setLogCallDetail] = useState<any>(null);
  const [editLogCall, setEditLogCall] = useState<LogCallDataUpdate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
  });

  const handleCreateLogCall = async () => {
    try {
      const logCallData = getNewLogCallData();
      const response = await createLogCall(logCallData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call created successfully!" });
        fetchLogCalls();
        resetAddLogCallForm();
      }
    } catch (err) {
      console.error("Error creating log call:", err);
      setResponse({ status: "error", message: "Log call created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateLogCall = async (logCallId: number) => {
    if (!editLogCall) return;
    const updatedLogCall: LogCallDataUpdate = {
      userCall: editLogCall.userCall || "",
      status: editLogCall.status ?? "",
      followUpDate: editLogCall.followUpDate
        ? new Date(
          new Date(editLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: editLogCall.note ?? "",
      assignType: editLogCall.assignType,
      assignRecord: editLogCall.assignRecord,
      targetType: editLogCall.targetType,
      targetRecord: editLogCall.targetRecord,
    };

    try {
      const response = await updateLogCall(logCallId, updatedLogCall);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call updated successfully!" });
        fetchLogCalls();
      }
    } catch (err) {
      console.error("Error updating log call:", err);
      setResponse({ status: "error", message: "Log call updated failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  useEffect(() => {
    if (companyDetail) {
      setAssignTaskType("ACCOUNT");
      setSelectedTaskAssignOption({ value: companyDetail.contactInformation.accountId, label: companyDetail.contactInformation.name });
    }
  }, [companyDetail]);
  useEffect(() => {
    if (newTaskData.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newTaskData.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
    if (newLogCall.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newLogCall.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
  }, [newTaskData.assignType, newLogCall.assignType, listLeadAssignType, listContactAssignType]);
  useEffect(() => {
    if (assignTaskOptions.length > 0) {
      setNewTaskData(prev => ({
        ...prev,
        assignId: companyDetail.contactInformation?.accountId ?? assignTaskOptions[0].value
      }));
    }
  }, [assignTaskOptions, companyDetail.contactInformation?.accountId]);
  useEffect(() => {
    if (companyDetail) {
      setNewTaskData(prev => ({
        ...prev,
        targetType: "ACCOUNT",
        assignId: companyDetail.contactInformation?.accountId ?? 0
      }));
      setNewEventData(prev => ({
        ...prev,
        targetType: "ACCOUNT"
      }));
      setNewLogCall(prev => ({
        ...prev,
        targetType: "ACCOUNT",
        targetRecord: companyDetail.contactInformation?.accountId ?? 0
      }));
    }
  }, [companyDetail]);

  const handleConfirmDeleteLogCall = async () => {
    if (!logCallToDelete) return;
    console.log(logCallToDelete)
    try {
      const response = await deleteLogCall(logCallToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setLogCalls((prevLogCalls) =>
          prevLogCalls.filter((logCall) => logCall.id !== logCallToDelete.id)
        );
        setResponse({ status: "success", message: "Log call deleted successfully!" });
      }
      setShowDeleteLogCallModal(false);
    } catch (err) {
      setResponse({ status: "error", message: "Log call deleted failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleConfirmDeleteTask = async () => {
    if (!taskToDelete) return;
    console.log(taskToDelete)
    try {
      const response = await deleteTask(taskToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setResponse({ status: "success", message: "Task deleted successfully!" });
        setTasks((prevTask) =>
          prevTask.filter((taskToDelete) => taskToDelete.id !== taskToDelete.id)
        );
        fetchTasks();
      }
    } catch (err) {
      console.error("Error deleting task", err);
      setResponse({ status: "error", message: "Task deleted failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateLogCallStatus = async (id: number, status: string) => {
    console.log(status, "abc");
    try {
      const response = await updateLogCallStatus(id, status);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call status updated successfully!" });
        fetchLogCalls();
      }
    } catch (error) {
      setResponse({ status: "success", message: "Log call status updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleEditClickLogCall = (id: number) => {
    console.log(id, "asdad");
    setSelectedLogCallId({ id });
    fetchSelectedLogCall(id);
  }
  const handleEditClickTask = (id: number) => {
    console.log(id, "asdad");
    setSelectedTaskId({ id });
    fetchSelectedTask(id);
  }

  const handleDeleteClickLogCall = (id: number) => {
    setLogCallToDelete({ id });
    setShowDeleteLogCallModal(true);
  };
  const handleDeleteClickTask = (id: number) => {
    setTaskToDelete({ id });
  };
  const handleClose3 = () => {
    setShow3(false);
  }
  const fetchLogCalls = async () => {
    if (!companyDetail.contactInformation?.accountId) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberLogCall("ACCOUNT", companyDetail.contactInformation?.accountId);
      setLogCalls(response.data.data || []);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };

  const fetchTasks = async () => {
    if (!companyDetail.contactInformation?.accountId) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberTasks("ACCOUNT", companyDetail.contactInformation?.accountId);
      setTasks(response.data.data || []);
    } catch (err) {
      console.error("Error fetching tasks", err);
      setError("Failed to load tasks.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (companyDetail.contactInformation?.accountId) {
      fetchLogCalls();
      fetchEvents();
      fetchTasks();
    }
  }, [companyDetail.contactInformation?.accountId]);
  //This method 
  const fetchListLeadAssignType = async () => {
    try {
      const response = await listLeadsOption();
      setListLeadAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching leads: ", err);
      setError("Failed to load leads.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListLeadAssignType();
  }, []);
  const fetchListContactAssignType = async () => {
    try {
      const response = await listContactsOptionn();
      setListContactAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching contacts: ", err);
      setError("Failed to load contacts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListContactAssignType();
  }, []);
  const fetchAccountRelatedToType = async () => {
    try {
      const response = await listAccountsOption();
      setListAccountRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts: ", err);
      setError("Failed to load accounts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountRelatedToType();
  }, []);
  const fetchListOpportunitiesRelatedToType = async () => {
    try {
      const response = await listOpportunitiesOption();
      setListOpportunitiesRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching opportunities: ", err);
      setError("Failed to load opportunities.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListOpportunitiesRelatedToType();
  }, []);
  const handleAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;
    setAssignType(selectedType);
    setSelectedAssignOption(null);
    if (selectedType === "LEAD") {
      setAssignOptions(
        listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }))
      );
    } else if (selectedType === "CONTACT") {
      setAssignOptions(
        listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }))
      );
    } else {
      setAssignOptions([]);
    }
  };
  const handleTaskAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }));
    }
    setAssignTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));

  };
  const handleTaskRelatedToTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({ value: t.accountId, label: t.accountName }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({ value: t.id, label: t.name }));
    }
    setRelateTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
  };
  const fetchSelectedLogCall = async (id: number) => {
    try {
      setSelectedLogCallId({ id });
      const response = await detailLogCall(id);
      const logCallData = response.data.data;
      setLogCallDetail(logCallData);
      setEditLogCall({
        userCall: logCallData.userCall?.uuid || "",
        status: logCallData.status || "",
        followUpDate: logCallData.followUpTime || "",
        note: logCallData.notes || "",
        assignType: logCallData.assignType || "",
        assignRecord: logCallData.assignee?.id || 0,
        targetType: logCallData.targetType || "",
        targetRecord: logCallData.targets?.id || 0,
      });
      if (logCallData.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (logCallData.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }

      if (logCallData.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (logCallData.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
      setShowEditLogCallModal(true);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setEditLogCall(prev => ({
      ...prev,
      assignRecord: assignTaskOptions.find(opt => opt.value === prev.assignRecord)?.value || 0
    }));
    setEditTaskData(prev => ({
      ...prev,
      assignRecord: assignTaskOptions.find(opt => opt.value === prev.assignId)?.value || 0
    }));
    setEditEventData(prev => ({
      ...prev,
      assignRecord: assignTaskOptions.find(opt => prev.assigneeId.includes(opt.value))?.value || 0
    }));
  }, [assignTaskOptions]);

  useEffect(() => {
    setEditLogCall(prev => ({
      ...prev,
      targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetRecord)?.value || 0
    }));
    setEditTaskData(prev => ({
      ...prev,
      targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetId)?.value || 0
    }));
    setEditEventData(prev => ({
      ...prev,
      targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetIds)?.value || 0
    }));
  }, [relateTaskOptions]);

  const fetchSelectedTask = async (id: number) => {
    try {
      setSelectedTaskId({ id: id });
      const response = await detailTask(id);
      console.log(response.data.data, "hihihhehehe");
      setEditingTask(response.data.data);

    } catch (err) {
      console.error("Error fetching task.", err);
      setError("Failed to load task.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (editingTask) {
      setEditTaskData({
        title: editingTask.title || "",
        category: editingTask.category || "",
        responsible: editingTask.responsible.uuid || "",
        startDate: editingTask.startDate || "",
        endDate: editingTask.endDate || "",
        status: editingTask.status || "",
        priority: editingTask.priority || "",
        description: editingTask.description || "",
        assignType: editingTask.assignType || "",
        assignId: editingTask.assignee.id ?? 0,
        targetType: editingTask.targetType || "",
        targetId: editingTask.assignee.id ?? 0,
      });
    }
  }, [editingTask]);
  useEffect(() => {
    setSelectedUserCall(editingLogCall?.userCall || "");
  }, [editingLogCall]
  );
  const fetchUserCallList = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUserCall(response.data.data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserCallList();
  }, []);
  const COLORS = ["success", "danger", "warning", "info", "pending", "pink"];
  const getStageColor = (index: number) => COLORS[index % COLORS.length];
  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const handleSelectChange = (e: any, field: string) => {
    setEditLogCall((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: field === "userCall" ? e.target.value : e?.target?.value || e.value,
      };
    });
    setEditingTask((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
    setEditEventData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setNewTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleUpdateTaskInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditEventData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "responsible") {
        const selectedUser = listUserCall.find(user => user.uuid === value);
        return {
          ...prevData,
          responsible: selectedUser ? { uuid: selectedUser.uuid, username: selectedUser.username } : prevData.responsible
        };
      }
      return {
        ...prevData,
        [name]: name === "memberId" || name === "assignId" || name === "targetId" ? Number(value) || 0 : value,
      };
    });
  };

  const handleUpdateTaskSelectChange = (name: string, value: string | number) => {
    setEditLogCall((prevData) => {
      if (!prevData) return prevData;

      if (name === "assignRecord") {
        return {
          ...prevData,
          assignRecord: value as number,
        };
      }

      if (name === "targetRecord") {
        return {
          ...prevData,
          targetRecord: value as number,
        };
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "assignId") {
        return {
          ...prevData,
          assignee: {
            ...prevData.assignee,
            id: value as number,
          },
        };
      }

      if (name === "targetId") {
        return {
          ...prevData,
          targets: {
            ...prevData.targets,
            id: value as number,
          },
        };
      }
      return {
        ...prevData,
        [name]: value,
      };
    });

  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">Companies Overview </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {/* Companies User */}
                <div className="contact-head">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to="/companies">
                            <i className="ti ti-arrow-narrow-left" />
                            Companies
                          </Link>
                        </li>
                        <li>{companyDetail.contactInformation.name}</li>
                      </ul>
                    </div>
                    <div className="col-sm-6 text-sm-end">
                      <div className="contact-pagination">
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body pb-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar avatar-xxl me-3 flex-shrink-0 border p-2">
                          <h6 className="text-default fw-medium">HT</h6>
                        </div>
                        <div>
                          <h5 className="mb-1">
                            {companyDetail.contactInformation.name}
                            <span className="star-icon">
                              <i className="fa-solid fa-star" />
                            </span>
                          </h5>
                          <p className="mb-0">
                            <i className="ti ti-map-pin-pin me-1" />
                            {companyDetail.contactInformation.city},{companyDetail.contactInformation.country}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Companies User */}
              </div>
              {/* Companies Sidebar */}
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body p-3">
                    <h6 className="mb-3 fw-semibold">Company Information</h6>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Website</span>
                        <span className="col-6">{companyDetail.contactInformation.website || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Phone</span>
                        <span className="col-6">{companyDetail.contactInformation.phone || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Language</span>
                        <span className="col-6">{companyDetail.contactInformation.language || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Status</span>
                        <span className="col-6">{companyDetail.contactInformation.status || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Rating</span>
                        <span className="col-6" style={{ color: ratingMap[companyDetail.contactInformation.rating]?.color || "#999", fontWeight: 600 }}>
                          {ratingMap[companyDetail.contactInformation.rating]?.text || "N/A"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Industry</span>
                        <span className="col-6">{companyDetail.contactInformation.industry || "N/A"}</span>
                      </li>
                    </ul>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Tags</h6>
                    <div>
                      {companyDetail?.tagList && companyDetail.tagList.length > 0 ? (
                        companyDetail.tagList.map((tag, index) => (
                          <Link
                            key={index}
                            to={`/tags/detail/${tag.tagId}`}
                            className="badge badge-soft-success fw-medium me-2"
                          >
                            {tag.name}
                          </Link>
                        ))
                      ) : (
                        <p className="text-muted">No tags available</p>
                      )}
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Owner</h6>
                    <span className="col-6">{companyDetail.contactInformation.ownerName}</span>
                    <hr />
                    <li className="row mb-3">
                      <span className="col-6">Created At</span>
                      <span className="col-6">{companyDetail.contactInformation.createdAt ? new Date(companyDetail.contactInformation.createdAt).toLocaleDateString() : "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Created By</span>
                      <span className="col-6">{companyDetail.contactInformation.createdBy || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Last Modifyied</span>
                      <span className="col-6">{companyDetail.contactInformation.updatedAt ? new Date(companyDetail.contactInformation.updatedAt).toLocaleDateString() : "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Modifyied By</span>
                      <span className="col-6">{companyDetail.contactInformation.updatedBy || "N/A"}</span>
                    </li>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Social Profile</h6>
                    <ul className="social-info">
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.facebookLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.linkedinLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.skypeLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-skype"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.whatsappLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.instagramLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={getValidUrl(companyDetail.contactInformation.twitterLink)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-twitter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Companies Sidebar */}
              {/* Companies Details */}
              <div className="col-xl-9">
                <div className="card mb-3">
                  <div className="card-body pb-0">
                    <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#activities"
                          className="nav-link active"
                          onClick={() => setReloadActivity(!reloadActivity)}
                        >
                          <i className="ti ti-alarm-minus me-1" />
                          Activities
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#tasks"
                          className="nav-link"
                        >
                          <i className="ti ti-list-check me-1" />
                          Tasks
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#events"
                          className="nav-link"
                        >
                          <i className="ti ti-calendar-event me-1" />
                          Events
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#calls"
                          className="nav-link"
                        >
                          <i className="ti ti-phone me-1" />
                          Calls
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Tab Content */}
                <div className="tab-content pt-0">
                  {/* Activities */}
                  <ActivityList id={id} type={ACTIVITY_TYPES.ACCOUNT} reload={reloadActivity} />
                  {/* /Activities */}
                  {/* Events */}
                  <div className="tab-pane fade" id="events">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Events</h4>
                        <div className="d-inline-flex align-items-center">
                          <button
                            className="btn btn-primary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#create_event"
                          >
                            <i className="ti ti-plus"></i> Add New Event
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {loading ? (
                          <p>Loading events...</p>
                        ) : error ? (
                          <p className="text-danger">{error}</p>
                        ) : events.length === 0 ? (
                          <div className="text-center p-5">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-calendar-event fs-24 text-primary"></i>
                            </div>
                            <h5>No events yet</h5>
                            <p className="text-muted">Create your first event by clicking the button above</p>
                          </div>
                        ) : (
                          events.map((event) => (
                            <div key={event.id} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-success">
                                    <i className="ti ti-calendar-event text-white"></i>
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <h6 className="fw-medium mb-0">Subject : {event.subject}</h6>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_event"
                                            onClick={() => handleEditClickEvent(event.id)}
                                          >
                                            <i className="ti ti-edit text-blue"></i> Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteEventClick(event.id)}
                                          >
                                            <i className="ti ti-trash text-danger"></i> Delete
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">Description: {event.description || "No description"}</p>
                                    <div className="d-flex flex-wrap gap-2 mb-1">
                                      <span className="badge bg-success">
                                        Start Time: {new Date(event.startTime).toLocaleString()}
                                      </span>
                                      <span className="badge bg-danger">
                                        End Time: {new Date(event.endTime).toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>

                    </div>
                  </div>
                  {/* Events */}
                  {/* Calls */}
                  <div className="tab-pane fade" id="calls">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Calls</h4>
                        <div>
                          <div className="d-flex">
                            <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_call">
                              <i className="ti ti-plus"></i> Add New Log Call
                            </button>
                            <div className="form-sort mt-0">
                              <i className="ti ti-sort-ascending-2" />
                              <Select
                                className="select"
                                options={ascendingandDecending}
                                placeholder="Ascending"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="card-body">
                        {logCalls.length > 0 ? (
                          logCalls.map((call, index) => (
                            <div key={index} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                    <i className="ti ti-phone" />
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <div>
                                        <span className="badge bg-primary me-2">{call.userCall || 'Unknown User'}</span>
                                        <span
                                          className={`badge ${call.status === 'BUSY' ? 'bg-danger' :
                                            call.status === 'NO_ANSWER' ? 'bg-warning' :
                                              call.status === 'LEFT_VOICE_MESSAGE' ? 'bg-info' :
                                                call.status === 'MOVING_FORWARD' ? 'bg-success' :
                                                  'bg-secondary'
                                            }`}
                                        >
                                          {call.status?.replace(/_/g, ' ')}
                                        </span>
                                      </div>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_call"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditClickLogCall(call.id);
                                            }}
                                          >
                                            <i className="ti ti-edit text-blue me-1" />
                                            Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#delete_logcall"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteClickLogCall(call.id)}
                                          >
                                            <i className="ti ti-trash text-danger me-1" />
                                            Delete
                                          </Link>

                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">{call.notes || 'No notes'}</p>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <p className="mb-0 text-muted small">
                                          <i className="ti ti-calendar me-1"></i>
                                          {call.callTime ? `Call time: ${new Date(call.callTime).toLocaleString()}` : 'No call time'}
                                        </p>
                                        <p className="mb-0 text-muted small">
                                          <i className="ti ti-calendar-event me-1"></i>
                                          {call.followUpTime ? `Follow-up: ${new Date(call.followUpTime).toLocaleString()}` : 'No follow-up'}
                                        </p>
                                      </div>
                                      <div className="dropdown">
                                        <button
                                          className={`btn btn-sm ${call.status === 'BUSY' ? 'btn-danger' :
                                            call.status === 'NO_ANSWER' ? 'btn-warning' :
                                              call.status === 'LEFT_VOICE_MESSAGE' ? 'btn-info' :
                                                call.status === 'MOVING_FORWARD' ? 'btn-success' :
                                                  'btn-secondary'
                                            } dropdown-toggle`}
                                          data-bs-toggle="dropdown"
                                        >
                                          {call.status?.replace(/_/g, ' ')}
                                        </button>
                                        <div className="dropdown-menu">
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'BUSY')}
                                          >
                                            Busy
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'NO_ANSWER')}
                                          >
                                            No Answer
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'UNAVAILABLE')}
                                          >
                                            Unavailable
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'WRONG_NUMBER')}
                                          >
                                            Wrong Number
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'LEFT_VOICE_MESSAGE')}
                                          >
                                            Left Voice Message
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'MOVING_FORWARD')}
                                          >
                                            Moving Forward
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center p-5">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-phone-call fs-24 text-primary"></i>
                            </div>
                            <h5>No calls logged yet</h5>
                            <p className="text-muted">Log your first call by clicking the button above</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* /Calls */}
                  {/* Tasks */}
                  <div className="tab-pane fade" id="tasks">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Tasks</h4>
                        <div>
                          <div className="d-flex">
                            <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_task">
                              <i className="ti ti-plus"></i> Add New Task
                            </button>
                            <div className="form-sort mt-0">
                              <i className="ti ti-sort-ascending-2" />
                              <Select
                                className="select"
                                options={ascendingandDecending}
                                placeholder="Ascending"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {/* Task list section */}
                        {tasks.length > 0 ? (
                          tasks.map((task, index) => (
                            <div key={index} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                    <i className="ti ti-notes" />
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <h6 className="fw-medium mb-0">{task.title}</h6>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_task"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditClickTask(task.id);
                                            }}
                                          >
                                            <i className="ti ti-edit text-blue"></i> Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#delete_task"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteClickTask(task.id)}
                                          >
                                            <i className="ti ti-trash text-danger me-1" />
                                            Delete
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">{task.description || 'No description'}</p>
                                    <div className="d-flex flex-wrap gap-2 mb-1">
                                      <span className="badge bg-info">Status: {task.status}</span>
                                      <span className="badge bg-warning">Priority: {task.priority}</span>
                                      <span className="badge bg-secondary">Category: {task.category}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar me-1"></i>
                                        Start: {new Date(task.startDate).toLocaleString()}
                                        {task.endDate ? ` | End: ${new Date(task.endDate).toLocaleString()}` : ' | No end date'}
                                      </p>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-user me-1"></i>
                                        {task.responsible.username || 'No responsible'}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center p-3">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-list-check fs-24 text-primary"></i>
                            </div>
                            <h5>No tasks found</h5>
                            <p className="text-muted">Create a new task to get started</p>
                          </div>
                        )}
                      </div>
                      {/* /Recent Task List */}
                    </div>
                  </div>
                  {/* /Tasks */}
                  {/* Notes */}
                  <div className="tab-pane fade" id="notes">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Notes</h4>
                        <div className="d-inline-flex align-items-center">
                          <div className="form-sort me-3 mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#add_notes"
                            className="link-purple fw-medium"
                          >
                            <i className="ti ti-circle-plus me-1" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="notes-activity">
                          <div className="card mb-3">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between pb-2">
                                <div className="d-inline-flex align-items-center mb-2">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-19.jpg"
                                      alt="img"
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Darlee Robertson
                                    </h6>
                                    <p className="mb-0">15 Sep 2023, 12:10 pm</p>
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <h5 className="fw-medium mb-1">
                                Notes added by Antony
                              </h5>
                              <p>
                                A project review evaluates the success of an
                                initiative and identifies areas for improvement.
                                It can also evaluate a current project to
                                determine whether it's on the right track. Or, it
                                can determine the success of a completed project.{" "}
                              </p>
                              <div className="d-inline-flex align-items-center flex-wrap">
                                <div className="note-download me-3">
                                  <div className="note-info">
                                    <span className="note-icon bg-secondary-success">
                                      <i className="ti ti-file-spreadsheet" />
                                    </span>
                                    <div>
                                      <h6 className="fw-medium mb-1">
                                        Project Specs.xls
                                      </h6>
                                      <p>365 KB</p>
                                    </div>
                                  </div>
                                  <Link to="#">
                                    <i className="ti ti-arrow-down" />
                                  </Link>
                                </div>
                                <div className="note-download">
                                  <div className="note-info">
                                    <span className="note-icon">
                                      <ImageWithBasePath
                                        src="assets/img/media/media-35.jpg"
                                        alt="img"
                                      />
                                    </span>
                                    <div>
                                      <h6 className="fw-medium mb-1">
                                        090224.jpg
                                      </h6>
                                      <p>365 KB</p>
                                    </div>
                                  </div>
                                  <Link to="#">
                                    <i className="ti ti-arrow-down" />
                                  </Link>
                                </div>
                              </div>
                              <div className="notes-editor">
                                <div
                                  className="note-edit-wrap"
                                  style={{ display: isEditor ? "block" : "none" }}
                                >
                                  <DefaultEditor className="summernote" />
                                  <div className="text-end note-btns">
                                    <Link
                                      to="#"
                                      className="btn btn-light add-cancel"
                                      onClick={() => setIsEditor(!isEditor3)}
                                    >
                                      Cancel
                                    </Link>
                                    <Link to="#" className="btn btn-primary">
                                      Save
                                    </Link>
                                  </div>
                                </div>
                                <div className="text-end">
                                  <Link
                                    to="#"
                                    className="add-comment link-purple fw-medium"
                                    onClick={() => setIsEditor(!isEditor)}
                                  >
                                    <i className="ti ti-square-plus me-1" />
                                    Add Comment
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-3">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between pb-2">
                                <div className="d-inline-flex align-items-center mb-2">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-20.jpg"
                                      alt="img"
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">Sharon Roy</h6>
                                    <p className="mb-0">18 Sep 2023, 09:52 am</p>
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <h5 className="fw-medium mb-1">
                                Notes added by Antony
                              </h5>
                              <p>
                                A project plan typically contains a list of the
                                essential elements of a project, such as
                                stakeholders, scope, timelines, estimated cost and
                                communication methods. The project manager
                                typically lists the information based on the
                                assignment.
                              </p>
                              <div className="d-inline-flex align-items-center flex-wrap">
                                <div className="note-download me-3">
                                  <div className="note-info">
                                    <span className="note-icon bg-secondary-success">
                                      <i className="ti ti-file-text" />
                                    </span>
                                    <div>
                                      <h6 className="fw-medium mb-1">
                                        Andrewpass.txt
                                      </h6>
                                      <p>365 KB</p>
                                    </div>
                                  </div>
                                  <Link to="#">
                                    <i className="ti ti-arrow-down" />
                                  </Link>
                                </div>
                              </div>
                              <div className="reply-box">
                                <p>
                                  The best way to get a project done faster is to
                                  start sooner. A goal without a timeline is just
                                  a dream.The goal you set must be challenging. At
                                  the same time, it should be realistic and
                                  attainable, not impossible to reach.
                                </p>
                                <p>
                                  Commented by{" "}
                                  <span className="text-purple">Aeron</span> on 15
                                  Sep 2023, 11:15 pm
                                </p>
                                <Link to="#" className="btn">
                                  <i className="ti ti-arrow-back-up-double" />
                                  Reply
                                </Link>
                              </div>
                              <div className="notes-editor">
                                <div
                                  className="note-edit-wrap"
                                  style={{
                                    display: isEditor2 ? "block" : "none",
                                  }}
                                >
                                  <DefaultEditor className="summernote" />
                                  <div className="text-end note-btns">
                                    <Link
                                      to="#"
                                      className="btn btn-light add-cancel"
                                      onClick={() => setIsEditor2(!isEditor3)}
                                    >
                                      Cancel
                                    </Link>
                                    <Link to="#" className="btn btn-primary">
                                      Save
                                    </Link>
                                  </div>
                                </div>
                                <div className="text-end">
                                  <Link
                                    to="#"
                                    className="add-comment link-purple fw-medium"
                                    onClick={() => setIsEditor2(!isEditor2)}
                                  >
                                    <i className="ti ti-square-plus me-1" />
                                    Add Comment
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-0">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between pb-2">
                                <div className="d-inline-flex align-items-center mb-2">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-21.jpg"
                                      alt="img"
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">Vaughan</h6>
                                    <p className="mb-0">20 Sep 2023, 10:26 pm</p>
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p>
                                Projects play a crucial role in the success of
                                organizations, and their importance cannot be
                                overstated. Whether it's launching a new product,
                                improving an existing
                              </p>
                              <div className="notes-editor">
                                <div
                                  className="note-edit-wrap"
                                  style={{
                                    display: isEditor3 ? "block" : "none",
                                  }}
                                >
                                  <DefaultEditor className="summernote" />
                                  <div className="text-end note-btns">
                                    <Link
                                      to="#"
                                      className="btn btn-light add-cancel"
                                      onClick={() => setIsEditor3(!isEditor3)}
                                    >
                                      Cancel
                                    </Link>
                                    <Link to="#" className="btn btn-primary">
                                      Save
                                    </Link>
                                  </div>
                                </div>
                                <div className="text-end">
                                  <Link
                                    to="#"
                                    className="add-comment link-purple fw-medium"
                                    onClick={() => setIsEditor3(!isEditor3)}
                                  >
                                    <i className="ti ti-square-plus me-1" />
                                    Add Comment
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Notes */}
                  {/* Calls */}
                  <div className="tab-pane fade" id="calls">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Calls</h4>
                        <div className="d-inline-flex align-items-center">
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#create_call"
                            className="link-purple fw-medium"
                          >
                            <i className="ti ti-circle-plus me-1" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="d-sm-flex align-items-center justify-content-between pb-2">
                              <div className="d-flex align-items-center mb-2">
                                <span className="avatar avatar-md me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-19.jpg"
                                    alt="img"
                                  />
                                </span>
                                <p>
                                  <span className="text-dark fw-medium">
                                    Darlee Robertson
                                  </span>{" "}
                                  logged a call on 23 Jul 2023, 10:00 pm
                                </p>
                              </div>
                              <div className="d-inline-flex align-items-center mb-2">
                                <div className="dropdown me-2">
                                  <Link
                                    to="#"
                                    className="bg-danger py-1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Busy
                                    <i className="ti ti-chevron-down ms-2" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      Busy
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      No Answer
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Unavailable
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Wrong Number
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Left Voice Message
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Moving Forward
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              A project review evaluates the success of an
                              initiative and identifies areas for improvement. It
                              can also evaluate a current project to determine
                              whether it's on the right track. Or, it can
                              determine the success of a completed project.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="d-sm-flex align-items-center justify-content-between pb-2">
                              <div className="d-flex align-items-center mb-2">
                                <span className="avatar avatar-md me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-20.jpg"
                                    alt="img"
                                  />
                                </span>
                                <p>
                                  <span className="text-dark fw-medium">
                                    Sharon Roy
                                  </span>{" "}
                                  logged a call on 28 Jul 2023, 09:00 pm
                                </p>
                              </div>
                              <div className="d-inline-flex align-items-center mb-2">
                                <div className="dropdown me-2">
                                  <Link
                                    to="#"
                                    className="bg-pending py-1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    No Answer
                                    <i className="ti ti-chevron-down ms-2" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      Busy
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      No Answer
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Unavailable
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Wrong Number
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Left Voice Message
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Moving Forward
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              A project plan typically contains a list of the
                              essential elements of a project, such as
                              stakeholders, scope, timelines, estimated cost and
                              communication methods. The project manager typically
                              lists the information based on the assignment.
                            </p>
                          </div>
                        </div>
                        <div className="card mb-0">
                          <div className="card-body">
                            <div className="d-sm-flex align-items-center justify-content-between pb-2">
                              <div className="d-flex align-items-center mb-2">
                                <span className="avatar avatar-md me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-21.jpg"
                                    alt="img"
                                  />
                                </span>
                                <p>
                                  <span className="text-dark fw-medium">
                                    Vaughan
                                  </span>{" "}
                                  logged a call on 30 Jul 2023, 08:00 pm
                                </p>
                              </div>
                              <div className="d-inline-flex align-items-center mb-2">
                                <div className="dropdown me-2">
                                  <Link
                                    to="#"
                                    className="bg-pending py-1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    No Answer
                                    <i className="ti ti-chevron-down ms-2" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      Busy
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      No Answer
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Unavailable
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Wrong Number
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Left Voice Message
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      Moving Forward
                                    </Link>
                                  </div>
                                </div>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              Projects play a crucial role in the success of
                              organizations, and their importance cannot be
                              overstated. Whether it's launching a new product,
                              improving an existing
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Calls */}
                  {/* Files */}
                  <div className="tab-pane fade" id="files">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="fw-semibold">Files</h4>
                      </div>
                      <div className="card-body">
                        <div className="card border mb-3">
                          <div className="card-body pb-0">
                            <div className="row align-items-center">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <h4 className="fw-medium mb-1">
                                    Manage Documents
                                  </h4>
                                  <p>
                                    Send customizable quotes, proposals and
                                    contracts to close deals faster.
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4 text-md-end">
                                <div className="mb-3">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#new_file"
                                  >
                                    Create Document
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card border shadow-none mb-3">
                          <div className="card-body pb-0">
                            <div className="row align-items-center">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <h4 className="fw-medium mb-1">
                                    Collier-Turner Proposal
                                  </h4>
                                  <p>
                                    Send customizable quotes, proposals and
                                    contracts to close deals faster.
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-md me-2 flex-shrink-0">
                                      <ImageWithBasePath
                                        src="assets/img/profiles/avatar-21.jpg"
                                        alt="img"
                                        className="rounded-circle"
                                      />
                                    </span>
                                    <div>
                                      <span className="fs-12">Owner</span>
                                      <p>Vaughan</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 text-md-end">
                                <div className="mb-3 d-inline-flex align-items-center">
                                  <span className="badge badge-danger-light me-1">
                                    Proposal
                                  </span>
                                  <span className="badge bg-pending priority-badge me-1">
                                    Draft
                                  </span>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-download text-info me-1" />
                                        Download
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card border shadow-none mb-3">
                          <div className="card-body pb-0">
                            <div className="row align-items-center">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <h4 className="fw-medium mb-1">
                                    Collier-Turner Proposal
                                  </h4>
                                  <p>
                                    Send customizable quotes, proposals and
                                    contracts to close deals faster.
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-md me-2 flex-shrink-0">
                                      <ImageWithBasePath
                                        src="assets/img/profiles/avatar-01.jpg"
                                        alt="img"
                                        className="rounded-circle"
                                      />
                                    </span>
                                    <div>
                                      <span className="fs-12">Owner</span>
                                      <p>Jessica</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 text-md-end">
                                <div className="mb-3 d-inline-flex align-items-center">
                                  <span className="badge badge-purple-light me-1">
                                    Quote
                                  </span>
                                  <span className="badge bg-success me-1">
                                    Sent
                                  </span>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-download text-info me-1" />
                                        Download
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card border shadow-none mb-0">
                          <div className="card-body pb-0">
                            <div className="row align-items-center">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <h4 className="fw-medium mb-1">
                                    Collier-Turner Proposal
                                  </h4>
                                  <p>
                                    Send customizable quotes, proposals and
                                    contracts to close deals faster.
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-md me-2 flex-shrink-0">
                                      <ImageWithBasePath
                                        src="assets/img/profiles/avatar-22.jpg"
                                        alt="img"
                                        className="rounded-circle"
                                      />
                                    </span>
                                    <div>
                                      <span className="fs-12">Owner</span>
                                      <p>Dawn Merhca</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 text-md-end">
                                <div className="mb-3 d-inline-flex align-items-center">
                                  <span className="badge badge-danger-light me-1">
                                    Proposal
                                  </span>
                                  <span className="badge bg-pending priority-badge me-1">
                                    Draft
                                  </span>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-edit text-blue me-1" />
                                        Edit
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-trash text-danger me-1" />
                                        Delete
                                      </Link>
                                      <Link className="dropdown-item" to="#">
                                        <i className="ti ti-download text-info me-1" />
                                        Download
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Files */}
                  {/* Email */}
                  <div className="tab-pane fade" id="email">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Email</h4>
                        <div className="d-inline-flex align-items-center">
                          <OverlayTrigger
                            placement="left"
                            overlay={
                              <Tooltip id="refresh-tooltip">
                                There are no email Companies configured, Please
                                configured your email Company in order to Send/
                                Create EMails
                              </Tooltip>
                            }
                          >
                            <Link to="#">
                              <i className="ti ti-circle-plus me-1" />
                              Create Email
                            </Link>
                          </OverlayTrigger>
                          {/* <Link
                      to="#"
                      className="link-purple fw-medium"
                      data-bs-toggle="tooltip"
                      data-bs-placement="left"
                      data-bs-custom-className="tooltip-dark"
                      data-bs-original-title=""
                    >
                      <i className="ti ti-circle-plus me-1" />
                      Create Email
                    </Link> */}
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card border mb-0">
                          <div className="card-body pb-0">
                            <div className="row align-items-center">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <h4 className="fw-medium mb-1">
                                    Manage Emails
                                  </h4>
                                  <p>
                                    You can send and reply to emails directly via
                                    this section.
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4 text-md-end">
                                <div className="mb-3">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#create_email"
                                  >
                                    Connect Company
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Email */}
                </div>
                {/* /Tab Content */}
              </div>
              {/* /Companies Details */}
            </div>
          </>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Create Contact */}
      <div className="modal custom-modal fade" id="create_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-user-plus" />
                </div>
                <h3>Contact Created Successfully!!!</h3>
                <p>View the details of contact, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Contact */}
      {/* Add Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={newEventData.subject}
                        onChange={(e) => setNewEventData({ ...newEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={newEventData.description}
                        onChange={(e) => setNewEventData({ ...newEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={newEventData.location}
                        onChange={(e) => setNewEventData({ ...newEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={attendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            maxHeight: "none",
                            flexWrap: "wrap",
                            overflowY: "auto",
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            flexWrap: "wrap",
                            maxHeight: "150px",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newEventData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option =>
                            newEventData.assigneeId && Array.isArray(newEventData.assigneeId)
                              ? newEventData.assigneeId.includes(option.value)
                              : false
                          )}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setNewEventData({
                              ...newEventData,
                              assigneeId: selectedOptions.length > 0
                                ? selectedOptions.map((option) => option.value)
                                : [],
                            })
                          }
                          isDisabled={assignTaskOptions.length === 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "none",
                              flexWrap: "wrap",
                              overflowY: "auto",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              flexWrap: "wrap",
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newEventData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newEventData.targetIds) || null}
                          onChange={(selectedOption) => setNewEventData({ ...newEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.startTime}
                          onChange={(e) => setNewEventData({ ...newEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.endTime}
                          onChange={(e) => setNewEventData({ ...newEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateEvent}>
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Add Event */}
      {/* /Update Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={editEventData.subject}
                        onChange={(e) => setEditEventData({ ...editEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={editEventData.description}
                        onChange={(e) => setEditEventData({ ...editEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={editEventData.location}
                        onChange={(e) => setEditEventData({ ...editEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={selectedAttendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={editEventData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option => editEventData.assigneeId.includes(option.value))}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setEditEventData({
                              ...editEventData,
                              assigneeId: selectedOptions.map((option) => option.value),
                            })
                          }
                          isDisabled={assignTaskOptions.length === 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "auto",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={editEventData?.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === editEventData.targetIds)}
                          onChange={(selectedOption) => setEditEventData({ ...editEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.startTime}
                          onChange={(e) => setEditEventData({ ...editEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.endTime}
                          onChange={(e) => setEditEventData({ ...editEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleUpdateEvent}>
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Update Event */}
      {/* Create Task */}
      <div className="modal custom-modal fade modal-padding" id="create_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={newTaskData.title}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.category ? { label: newTaskData.category, value: newTaskData.category } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, category: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select
                        className="form-control"
                        name="responsible"
                        value={newTaskData.responsible}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map((user) => (
                          <option key={user.uuid} value={user.uuid}>
                            {user.username}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newTaskData.assignId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, assignId: selectedOption?.value || 0 })}
                          isDisabled={assignTaskOptions.length === 0}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newTaskData.targetId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, targetId: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>


                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="startDate"
                          value={newTaskData.startDate}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="endDate"
                          value={newTaskData.endDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select
                        options={selectTaskStatusOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.status ? { label: newTaskData.status, value: newTaskData.status } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, status: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select
                        options={selectTaskPriorityOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.priority ? { label: newTaskData.priority, value: newTaskData.priority } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, priority: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        rows={4}
                        value={newTaskData.description}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateTasks}>
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Create Task */}
      {/*Update Task*/}
      <div className="modal custom-modal fade modal-padding" id="edit_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="title" value={editingTask?.title || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        name="category"
                        value={selectTaskCategoryOptions.find(opt => opt.value === editingTask?.category)}
                        onChange={(option) => handleUpdateTaskSelectChange("category", option?.value ?? "")}
                        classNamePrefix="react-select"
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select className="form-control" name="responsible" value={editingTask?.responsible.uuid || ""} onChange={handleUpdateTaskInputChange}>
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map(user => (
                          <option key={user.uuid} value={user.uuid}>{user.username}</option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" value={selectAssignType.find(option => option.value === editingTask?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editingTask?.assignee?.id) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignId", option?.value || 0)}
                          isDisabled={assignTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editingTask?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editingTask?.targets?.id) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetId", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input type="datetime-local" className="form-control" name="startDate" value={editingTask?.startDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input type="datetime-local" className="form-control" name="endDate" value={editingTask?.endDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select options={selectTaskStatusOptions}
                        value={selectTaskStatusOptions.find(opt => opt.value === editingTask?.status)}
                        onChange={(option) => handleUpdateTaskSelectChange("status", option?.value || "")} />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select options={selectTaskPriorityOptions} placeholder="Choose"
                        value={selectTaskPriorityOptions.find(opt => opt.value === editingTask?.priority)}
                        onChange={(option) => handleUpdateTaskSelectChange("priority", option?.value || "")} classNamePrefix="react-select" />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea className="form-control" rows={4} name="description" value={editingTask?.description || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedTaskId?.id && handleUpdateTask(selectedTaskId?.id)}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/*Update Task*/}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={newLogCall.userCall}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, userCall: e.target.value }))}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        onChange={(selected) => {
                          if (selected) {
                            setNewLogCall((prev) => ({ ...prev, status: selected.value }));
                          }
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={newLogCall.followUpDate}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, followUpDate: e.target.value }))}
                      />
                    </div>
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newLogCall.assignRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, assignRecord: selectedOption?.value || 0 })}
                          isDisabled={assignTaskOptions.length === 0}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newLogCall.targetRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, targetRecord: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        value={newLogCall.note}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="checkboxs">
                        <input
                          type="checkbox"
                          checked={newLogCall.checkedCreateFollowingTask}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, checkedCreateFollowingTask: e.target.checked }))}
                        />
                        <span className="checkmarks" /> Create a Follow-Up task
                      </label>
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button"
                        onClick={handleCreateLogCall}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Edit Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={editLogCall?.userCall || ""}
                          onChange={(e) => handleSelectChange(e, "userCall")}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        name="status"
                        value={statusList.find((status) => status.value === editLogCall?.status)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="followUpDate"
                          value={editLogCall?.followUpDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" value={selectAssignType.find(option => option.value === editLogCall?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editLogCall?.assignRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignRecord", option?.value || 0)}
                          isDisabled={assignTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editLogCall?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editLogCall?.targetRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetRecord", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        name="note"
                        value={editLogCall?.note || ""}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedLogCallId?.id && handleUpdateLogCall(selectedLogCallId?.id)}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_logcall"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Call Log?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this call log?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteLogCall()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_task"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Task?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this task?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteTask()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Owner */}
      <div className="modal custom-modal fade" id="owner" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Deal Owner</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" defaultChecked />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-19.jpg" alt="" />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-20.jpg" alt="" />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-21.jpg" alt="" />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="" />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-16.jpg" alt="" />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-22.jpg" alt="" />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Owner */}
      {/* Deal Status */}
      <div className="modal custom-modal fade" id="deal_status" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deal Status</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    classNamePrefix="react-select"
                    // options={status}
                    placeholder="Choose"
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea className="form-control" rows={5} defaultValue={""} />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Deal Status */}
      {/* Add New Pipeline */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_pipeline"
      >
        <div className="offcanvas-header border-bottom">
          <h4>Add New Pipeline</h4>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form >
            <div>
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input className="form-control" type="text" />
              </div>
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <Link
                    to="#"
                    className="add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    <i className="ti ti-square-rounded-plus" />
                    Add New
                  </Link>
                </div>
                <div className="pipeline-listing">
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Inpipeline
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Follow Up
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Schedule Service
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="form-title">Access</h5>
                <div className="d-flex flex-wrap access-item nav">
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="all"
                      name="status"
                      defaultChecked
                    />
                    <label htmlFor="all">All</label>
                  </div>
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#select-person"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="select"
                      name="status"
                    />
                    <label htmlFor="select">Select Person</label>
                  </div>
                </div>
                <div className="tab-content mb-3">
                  <div className="tab-pane fade" id="select-person">
                    <div className="access-wrapper">
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt="Image"
                          />
                          Vaughan
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt="Image"
                          />
                          Jessica
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#create_pipeline"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Pipeline */}
      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}
      {/* Create Pipeline */}
      <div className="modal custom-modal fade" id="create_pipeline" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Pipeline Created Successfully!!!</h3>
                <p>View the details of pipeline, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Pipeline*/}
      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}
      {/* Delete Stage */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Stage?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> stage you selected.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <Link to={route.contactList} className="btn btn-danger">
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
      {/* /Delete Stage */}

    </>
  );
};

export default CompaniesDetails;
